import axios from "axios";
import { domain } from "../../../Links/Links";

export async function depositsHistoryRequest(setRequestStatus, setData) {
    setRequestStatus(true);

    const response = await axios.get(domain + '/deposits_history/' , {
        withCredentials: true,
    })

    console.log(response.data);

    if (response.data) {
        setData(response.data);
        setRequestStatus(false);
    }
}